<template>
	<el-drawer :modal="false"  title="Filter" :visible.sync="drawerFilterCreditReports" class="drawer-filter-credit-reports" size="20%">

		<b-container>
			<b-row class="text-end">
				<b-col cols="12">
					<div class="d-flex justify-content-end">
						<b-button variant="primary" @click="resetFilter">Reset</b-button>
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<b-form-group label="Customer Name">
						<b-form-input type="text" v-model="filter.customer_name" placeholder="Filter By Customer Name"
							@input="debouncedHandler"></b-form-input>
					</b-form-group>
				</b-col>
        <b-col cols="12">
					<b-form-group label="Platform">
						<b-form-input type="text" v-model="filter.platform" placeholder="Filter By Platform"
							@input="debouncedHandler"></b-form-input>
					</b-form-group>
				</b-col>
        	<b-col cols="12">
					<b-form-group label="Customer NRIC">
						<b-form-input type="text" v-model="filter.customer_nric" placeholder="Filter By Customer Name"
							@input="debouncedHandler"></b-form-input>
					</b-form-group>
				</b-col>
        <b-col cols="12">
          <div>
            <label class="mb-2 d-block">Requested Date</label>
            <div class="mb-2">
              <el-date-picker
                v-model="filter.value1"
                type="date"
                placeholder="Date From"
                value-format="yyyy-MM-dd"
                @change="filterByDate()"
              />
            </div>
            <div class="mb-2 w-100 text-center">
              To
            </div>
            <div>
              <el-date-picker
                v-model="filter.value2"
                type="date"
                placeholder="Date Until"
                value-format="yyyy-MM-dd"
                @change="filterByDate()"
              />
            </div>
          </div>
        </b-col>
			</b-row>
		</b-container>

	</el-drawer>
</template>
<script>
import { Button, Drawer, Select, Option, DatePicker, Switch, Radio, RadioGroup } from 'element-ui'
// import { LEADS_TYPE_FILTER } from '@/assets/js/status.js'
import { mapState, mapActions } from 'pinia'
import { useAccessControlStore } from '@/stores/accessControlStore'
import {
	helperFunctionMixin,
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
	debounce
} from '@/assets/js/httpImports.js'

export default {
	name: 'drawer-filter-credit-reports',

	mixins: [
		helperFunctionMixin,
	],
	components: {
		[Button.name]: Button,
		[Drawer.name]: Drawer,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
		[Switch.name]: Switch,
		[Radio.name]: Radio,
		[RadioGroup.name]: RadioGroup,
	},
	computed: {

	},
	created() {
 
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
			this.searchByFilter();
		}, 1000);
	},
	data() {
		return {
			// LEADS_TYPE_FILTER: LEADS_TYPE_FILTER,
			drawerFilterCreditReports: false,
			filter: {
				customer_name: "",
        platform: "",
			  requested_date: "",
        customer_nric: "",
			},
			debouncedHandler: '',
		};
	},
	methods: {
		...mapActions(useAccessControlStore, ['getUsers']),
		viewFilterCreditReports() {
			this.drawerFilterCreditReports = !this.drawerFilterCreditReports;
		},
		searchByFilter() {
			// this.$emit('filter_assigned_to',[this.filter.se, this.filter.ssa, this.filter.sse])
			this.$emit('filter_by', this.filter)
		},
    filterByDate() {
			if (this.filter.value1 && this.filter.value2) {
				this.filter.date_range = `${this.filter.value1},${this.filter.value2}`
				this.searchByFilter()
			} else if (!this.filter.value1 && !this.filter.value2) {
				this.filter.date_range = ''
				this.searchByFilter()
			}
		},
		resetFilter() {
			Object.keys(this.filter).forEach(key => {
				this.filter[key] = ''
			});
			this.searchByFilter()
		},
	}
}
</script>